import { render } from "./AdblockTopbar.vue?vue&type=template&id=a96fb46c&scoped=true"
import script from "./AdblockTopbar.vue?vue&type=script&lang=js"
export * from "./AdblockTopbar.vue?vue&type=script&lang=js"

import "./AdblockTopbar.vue?vue&type=style&index=0&id=a96fb46c&scoped=true&lang=css"

import exportComponent from "/var/www/ab-front-library/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a96fb46c"]])

export default __exports__